import {
	type FetchChainStakingStakeOperationsUserData,
	type FetchChainStakingStakeOperationsUserParams,
	type Image,
	SociosApi,
	type WalletCurrency
} from '@capsicum/common';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { chainStakingApi } from '../api';

type FetchChainStakingStakeOperationsUserDataWithCurrency = {
	data: Array<
		FetchChainStakingStakeOperationsUserData['data'][number] & {
			currency?: WalletCurrency & {
				images: Array<Image>;
			};
		}
	>;
};

export const useFanTokenStakingSearchStakeOperationQuery = (
	{ 'currencyIds[]': currencyIds, 'statuses[]': statuses }: FetchChainStakingStakeOperationsUserParams,
	options?: Omit<UseQueryOptions<FetchChainStakingStakeOperationsUserDataWithCurrency>, 'queryFn' | 'queryKey'>
) =>
	useQuery({
		queryFn: async () => {
			return (await chainStakingApi).fetchChainStakingStakeOperationsUser(
				{
					'currencyIds[]': currencyIds,
					'statuses[]': statuses
				},
				{
					headers: SociosApi.prepareEDTOHeaders([
						{
							at: '/data/*/currencyId',
							details: ['currencyImages'],
							fetch: 'WalletService:Currency:byId',
							into: 'currency'
						}
					])
				}
			) as Promise<FetchChainStakingStakeOperationsUserDataWithCurrency>;
		},
		queryKey: ['fanTokenStaking', 'stakeOperation', currencyIds, statuses],
		...options,
		enabled: Boolean(currencyIds?.length),
		select: data => data.data
	});
